
import { defineComponent, watch, ref, onMounted } from 'vue'

export default defineComponent({
    props: {
        sliderId: {
            type: Number,
            default: () => Number(String(Date.now()) + String(Math.floor(Math.random() * 1000)))
        },
        slidesCount: {
            type: Number,
            default: 1
        },
        slidesToShow: {
            type: Number,
            default: 3
        },
        value: {
            type: Number,
            default: 1,
        }
    },
    setup(props) {
        const sliderContainerRef = ref<HTMLElement | null>(null)

        const updateView = () => {
            if (props.value < 1 || props.value > props.slidesCount) {
                return
            }

            const sliderContainer = sliderContainerRef.value as HTMLElement
            const element = document.getElementById(`nv-slider-${props.sliderId}-slide-${props.value}`)

            if (element) {
                let left = 0

                if (props.value > 1) {
                    left = element.offsetLeft - element.clientWidth
                }

                sliderContainer.scrollTo({ behavior: 'smooth', left })
            }
        }

        onMounted(updateView)
        watch(() => props.value, updateView)

        return {
            sliderContainerRef
        }
    }
})
